import {IToJson} from '@toolify/client/src/types/IToJson'
import {IDeploymentVersionItemBlockResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDeploymentVersionItemBlockResponseInstance'
import {IFileResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileResponseInstance'
import {mapFileResponseInstance} from '@toolify/client/src/modules/api/singletons/mapFileResponseInstance'
import {DeploymentVersionItemBlockType} from '@toolify/server/src/models/mongoose/DeploymentVersionItemBlockModel/enum/DeploymentVersionItemBlockType'

export function mapDeploymentVersionItemBlockResponseInstance(
  block: IToJson<IDeploymentVersionItemBlockResponseInstance>,
): IDeploymentVersionItemBlockResponseInstance {
  if(block.type === DeploymentVersionItemBlockType.Markdown || !block.payload.file) {
    return {
      ...block,
    }
  }
  return {
    ...block,
    payload: {
      ...block.payload,
      file: mapFileResponseInstance(block.payload.file as IToJson<IFileResponseInstance>),
    },
  }
}
